import { useContext } from "react";
import { MainMenuContext } from "../providers/MainMenuProvider";

export const useMainMenu = () => {
  const ctx = useContext(MainMenuContext);

  if (!ctx) throw new Error("Please wrap useMainMenu into MainMneuProvider");

  return ctx;
};
